export function getCmsVideoUrl(asset) {
    return asset?.video?.mp4Url || asset?.url || ''
}

export function getCmsPosterUrl(poster, asset) {
    return poster?.url || asset?.video?.thumbnailUrl || ''
}
